import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router'
import store from './store'
import currencyDirective from './directives/CurrencyDirective'
import integerDirective from './directives/IntegerDirective'

Vue.use(VueMeta)

Vue.config.productionTip = false
Vue.directive('currency', currencyDirective)
Vue.directive('integer', integerDirective)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
